module.exports = __webpack_public_path__ + "static/img/home-img2.28e157e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-img2.png
// module id = 1F/l
// module chunks = 1